module.exports = __webpack_public_path__ + "img/u190_1295_310_area_a2_cmyk_eci.f2e9c74e.jpg";